import http from '@/http/service'
  

export default function Motoristas(params={}){

    return http.get("/admin/motoristas",{ params })

}